import React, { Component } from 'react';
import { App } from '../App'
import IconButton, {IconBookmark, IconBookmarked, IconLike, IconLikeRed, IconFinger, IconRefFactory, IconSelected, IconSelect, IconTrash, IconOffendedFilled, IconOffended, IconSuspectYes, IconSuspect, VoteButton, ScaledIcon, IconPhoto, IconSplotch, IconStartWith } from './iconButton';
import { User } from 'oidc-client';
import { STrace, SmesshyCommon, SmesshyCommonProps, SmesshyCommonState } from '../smesshyCommon';
import { ChallengeState, MakePaintingLocate, PaintingInfo } from '../storageManager';
import { Navigate } from 'react-router';
import { createSearchParams } from 'react-router-dom';
import { FollowingTile } from './followingPage';
import { CountdownTimer } from './countDownText';


export interface ChallengeTileState extends SmesshyCommonState {
    expandedView: boolean;
    challengeState: ChallengeState | undefined;
}

export interface ChallengeTileOptions {
    ShowResults: boolean;
    ShowTitle: boolean;
    ShowRules: boolean;
    ShowPrize: boolean;
    ShowEntrants: boolean;
    Prefix: string;
    Expanded?: boolean;
}

export interface ChallengeTileProps extends SmesshyCommonProps {
    Options: ChallengeTileOptions;
    TotalVotes?: number;
    TotalPoints?: number;
    FinalRank?: number;
    Title: string;
    Id: number;
    OnChallengeStateNeeded: (id: number)=>Promise<ChallengeState>;
    OnExpandContract?: (expanded: boolean)=>void;
}

class ChallengeTile extends SmesshyCommon(Component<ChallengeTileProps, ChallengeTileState>) {

    rectRef = React.createRef() as React.RefObject<HTMLDivElement>;
    constructor(props: ChallengeTileProps) {
        super(props);
        this.initCommon(props.AppObject);

        this.state = {
            showWaitSpin: false,
            authenticated: false,
            expandedView: props.Options.Expanded === true,
            challengeState: undefined
        };
    }
    requestingStateForId: number = -1;

    componentDidUpdate(prevProps: Readonly<ChallengeTileProps>, prevState: Readonly<ChallengeTileState>): void {
        if (this.props.Id !== -1 && (this.state.challengeState === undefined || this.state.challengeState!.challengeId !== this.props.Id) && this.isChallengeStateUsed()) {
            if (this.requestingStateForId === this.props.Id) {
                return;
            }
            this.requestingStateForId = this.props.Id;
            let controlThis = this;

            this.props.OnChallengeStateNeeded(this.props.Id).then((cs) => {
                if (cs.challengeId > 1) {
                    controlThis.setState({challengeState: cs});
                }
                controlThis.requestingStateForId = -1;
            });
        }
        if (this.props.OnExpandContract !== undefined && this.state.expandedView !== prevState.expandedView) {
            this.props.OnExpandContract(this.state.expandedView);
        }
    }

    componentDidMount(): void {
        if (this.isChallengeStateNeeded()) {
            this.requestingStateForId = this.props.Id;
            let controlThis = this;

            this.props.OnChallengeStateNeeded(this.props.Id).then((cs) => {
                if (cs.challengeId > 1) {
                    controlThis.setState({challengeState: cs});
                }
                controlThis.requestingStateForId = -1;
            });
        }
        if (this.props.OnExpandContract !== undefined) {
            this.props.OnExpandContract(this.state.expandedView);
        }

        
    }
    componentWillUnmount() {
    }

    isChallengeStateUsed(): boolean {
        if (this.state.expandedView === true) {
            return true;
        }
        if (this.props.Options.ShowPrize === true || this.props.Options.ShowRules === true || this.props.Options.ShowEntrants === true) {
            return true;
        }
        return false;
    }

    isChallengeStateNeeded(force: boolean = false): boolean {
        if (force === true) {
            return true;
        }
        if (this.isChallengeStateUsed() === false) {
            return false;
        }
        if (this.state.challengeState !== undefined) {
            return false;
        }
        return true;
    }



    render() {
        try {
            return this.babyRender();
        } catch (e: any) {
            this.props.AppObject.reportException(`ChallengeTile, render`, 'ex', '', e)
            return <div>?!?!</div>;
        }
    }
    babyRender() {

        let prefix = this.props.Options.Prefix === undefined ? <></> : <div>{this.props.Options.Prefix}</div>;
        let title = this.props.Options.ShowTitle === false ? <></> : <div className='text-medium text-bold text-blue text-clip'>{this.props.Title}</div>;

        if (this.isChallengeStateNeeded()) {
            return this.renderFramework(
                <div ref={this.rectRef} className='v-items v-small-gap smesshy-challenge-panel'> 
                    <div className='h-items each-cross-center each-space-between'> 
                        <div className='h-items h-medium-gap each-cross-center'> 
                            {prefix}
                            {title}
                        </div>
                    </div>
                    <div>
                        Getting the challenge details...
                    </div>
                </div>, this.state);
        }

        let iconSvgSizeSmall = this._app!.GetScaledPxHeight(14);
        let iconSvgSizeBig = this._app!.GetScaledPxHeight(24);

        const onChallengeClick = ()=> {
            STrace.addStep('challenge', 'expand', (!this.state.expandedView).toString());
            this.setState({expandedView: !this.state.expandedView});
            // if (this.state.expandedView === false && this.state.challengeState === undefined) {
            //     this.props.OnChallengeStateNeeded(this.props.Id).then((cs) => {
            //         this.setState({challengeState: cs});
            //     });
            // }
        };

        let challengeState = this.state.challengeState;
        let showRules = <></>;
        let prize = <></>;
        let canStamp: boolean = false;
        let hasStyleGuide: boolean = false;
        let hasStartWith: boolean = false;
        let hasColorRestrictions: boolean = false;
        let hasTimeLimit: boolean = false;

        if (challengeState !== undefined) {
            prize = this.props.Options.ShowPrize === false ? <></> : <div className='text-medium'>{`$${challengeState.prizePool}`}</div>;
            canStamp = challengeState.rules === undefined || challengeState.rules === null ||
                            challengeState.rules.stamps === undefined || challengeState.rules.stamps === null ? challengeState.stampAllowed : challengeState.rules.stamps;
            let stamp = canStamp ? <div>{ScaledIcon(IconPhoto(undefined), iconSvgSizeSmall)}</div> : <> </>;
            hasStartWith = challengeState.rules !== undefined && challengeState.rules !== null && 
                            challengeState.rules.startingWith !== undefined && challengeState.rules.startingWith !== null && 
                            challengeState.rules.startingWith.length > 0;
            let startWith = hasStartWith ? <div className='smesshy-icon-button-pushed'>{ScaledIcon(IconStartWith(undefined), iconSvgSizeSmall)}</div> : <> </>;
            hasColorRestrictions = challengeState.rules !== undefined && challengeState.rules !== null && 
                            challengeState.rules.colorRestrictions !== undefined && challengeState.rules.colorRestrictions !== null && 
                            challengeState.rules.colorRestrictions.length > 0;
            let colorRestrictions = <></>;
            if (hasColorRestrictions) {
                colorRestrictions = <div className='h-items'>
                    {challengeState.rules.colorRestrictions.map((c, i) => {
                        return <div key={i} className=''>{ScaledIcon(IconSplotch(c), iconSvgSizeSmall)}</div>
                    })}
                </div>

            }
            hasTimeLimit = challengeState.rules !== undefined  && challengeState.rules !== null && 
                                challengeState.rules.timeLimit !== undefined && challengeState.rules.timeLimit !== null &&
                                challengeState.rules.timeLimit > 0;
            let time = !hasTimeLimit ? <></> : <div className='text-small'>{CountdownTimer.secondsToTime(challengeState.rules.timeLimit)}</div>;
            hasStyleGuide = challengeState.rules !== undefined && challengeState.rules !== null && 
                                challengeState.rules.styleGuide !== undefined && challengeState.rules.styleGuide !== null &&
                                challengeState.rules.styleGuide.length > 0;
            let styleGuide = !hasStyleGuide ? <></> : <div className='text-small'>Style: {challengeState.rules.styleGuide}</div>;
            let entriesCaption = 'Entries: ';
            let entries  = this.props.Options.ShowEntrants ? <div className='text-small'>{`${entriesCaption}${challengeState.entries}`}</div> : <></>;

            showRules = this.props.Options.ShowRules === false ? <></> : 
                <div className='h-items each-cross-center each-space-between'> 
                    <div className='h-items h-medium-gap each-cross-center'>
                        {stamp}
                        {startWith}
                        {colorRestrictions}
                        {time}
                        {styleGuide}
                    </div>
                    {entries}
                </div>;
        }

        let showResults = this.props.Options.ShowResults === false ? <></> :
            <div style={{display:'grid'}}>
                <div className='text-small h-padding-small' style={{gridRow:1, gridColumn:1}}>
                    Rank:
                </div>
                <div className='text-small h-padding-small' style={{gridRow:1, gridColumn:2}}>
                    {this.props.FinalRank === undefined || this.props.FinalRank === 0 ? 'unknown' : this.props.FinalRank}
                </div>
                <div className='text-small h-padding-small' style={{gridRow:2, gridColumn:1}}>
                    {`Points/Votes`}
                </div>
                <div className='text-small h-padding-small' style={{gridRow:2, gridColumn:2}}>
                    {this.props.TotalVotes === undefined || this.props.TotalVotes === 0 || this.props.TotalPoints === undefined ? 'unknown' : 
                        `${this.props.TotalPoints}/${this.props.TotalVotes} = ${Math.round(this.props.TotalPoints/this.props.TotalVotes*10)/10}`}
                </div>
            </div>

        return (
            <>
                <div ref={this.rectRef} className='v-items v-small-gap smesshy-challenge-panel' onPointerUp={(e)=>onChallengeClick()}> 
                    <div className='h-items each-cross-center each-space-between'> 
                        <div className='h-items h-medium-gap each-cross-center'> 
                            {prefix}
                            {title}
                        </div>
                        {prize}
                    </div>
                    {showRules}
                    {showResults}
                </div>
                {this.state.expandedView && (
                <div onPointerUp={(e)=>onChallengeClick()} 
                        style={{maxWidth:512, maxHeight: 1024, position:'absolute', left:0, top: 0, height:'100%', width:'100%', backgroundColor:'rgba(0,0,0,.67)', zIndex: 10}}>
                    <div className='width-100p v-items each-cross-center' style={{position:'relative', left:0, top: this.bestTop(this.rectRef.current!, 215, 'centered'), zIndex:100}}>
                        <div className='text-large'>Challenge Details</div>
                        <div className='v-items v-small-gap smesshy-challenge-panel v-padding-medium h-padding-medium'> 

                            <div style={{display:'grid'}}>
                                <div className='text-medium border-thin' style={{gridRow:1, gridColumn:1}}>
                                    Title
                                </div>
                                <div className='h-padding-small' style={{gridRow:1, gridColumn:2}}>
                                    {title}
                                </div>
                                <div className='text-medium  border-thin' style={{gridRow:2, gridColumn:1}}>
                                    Prize pool
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:2, gridColumn:2}}>
                                    {`$${challengeState!.prizePool}`}
                                </div>
                                <div className='text-medium  border-thin' style={{gridRow:3, gridColumn:1}}>
                                    Entrants
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:3, gridColumn:2}}>
                                    {challengeState!.entries}
                                </div>
                                <div className='text-medium  border-thin' style={{gridRow:4, gridColumn:1}}>
                                    Use stamps?
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:4, gridColumn:2}}>
                                    {canStamp === true ? 
                                    <div className='h-items'>
                                        <div className='text-medium'>
                                            {ScaledIcon(IconPhoto(undefined), iconSvgSizeBig)}
                                        </div>
                                        <div className='text-medium'>
                                            Yes 
                                        </div>
                                    </div>:
                                    'No'}
                                </div>

                                <div className='text-medium  border-thin' style={{gridRow:5, gridColumn:1}}>
                                    Style Guide
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:5, gridColumn:2}}>
                                    {!hasStyleGuide ? 'Anything goes' : challengeState!.rules.styleGuide}
                                </div>
                                <div className='text-medium border-thin' style={{gridRow:6, gridColumn:1}}>
                                    Start with
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:6, gridColumn:2}}>
                                    {!hasStartWith ? 
                                    'A blank page' :
                                    <div className='h-items'>
                                        <div className='text-medium'>
                                            {ScaledIcon(IconStartWith(undefined), iconSvgSizeBig)}
                                        </div>
                                        <div className='text-medium'>
                                            A Surprise 
                                        </div>
                                    </div>}
                                </div>
                                <div className='text-medium border-thin' style={{gridRow:7, gridColumn:1}}>
                                    Time limit
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:7, gridColumn:2}}>
                                    {!hasTimeLimit ? 'None (except the deadline)' : `Yes, only ${CountdownTimer.secondsToTime(challengeState!.rules.timeLimit)} minutes!`}
                                </div>
                                <div className='text-medium border-thin' style={{gridRow:8, gridColumn:1}}>
                                    Colors
                                </div>
                                <div className='h-padding-small text-medium' style={{gridRow:8, gridColumn:2}}>
                                    {!hasColorRestrictions ? 
                                    'Any you can make (a lot)' :
                                    <div className='h-items'>
                                        <div className='text-medium'>
                                            Only these:
                                        </div>
                                        {challengeState!.rules.colorRestrictions.map((c, i) => {
                                            return <div key={i} className=''>{ScaledIcon(IconSplotch(c), iconSvgSizeBig)}</div>
                                        })}

                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </>);
    }
}

export default ChallengeTile;